
// import AOS from 'aos'
import { Fancybox } from "@fancyapps/ui";

import 'aos/dist/aos.css'

export default {
	props: {
		slideLimit: {
			type: Number,
			default: 0
		},
		slideTo: {
			type: Number,
			default: 15
		},
	},
	mounted() {
		this.galery !== false && Fancybox.bind(`[data-fancybox="gallery-dealer"]`, {
			groupAll: true,
			compact: this.$device.isMobile ? true : false

		})
		const sliderIndexSwiper = new swiper.default('.slider-dealer .swiper', {
			modules: [swiper.Navigation, swiper.Pagination, swiper.Autoplay],
			loop: true,
			autoplayDisableOnInteraction: false,
			// autoHeight: true,
			watchSlidesProgress: true,
			scrollbar: false,
			speed: 330,

			// on: {
			// 	sliderMove: this.sliderMove,
			// 	slideChangeTransitionStart: this.slideChangeTransitionStart
			// },
			// pagination: {
			// 	el: '.swiper-pagination',
			// 	clickable: 'true',
			// 	type: 'bullets',
			// 	renderBullet: function (index, className) {
			// 		return '<span class="' + className + '">' + '<span class="swiper-pagination-bar"></span>' + '<span class="swiper-pagination-progress"></span>' + '</span>';
			// 	},
			// },
			
			navigation: {
				nextEl: '.swiper-button-next--dealer',
				prevEl: '.swiper-button-prev--dealer',
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1,
					spaceBetween: 10
				},
				// when window width is >= 480px
				480: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 1,
					spaceBetween: 16
				}
			},
		})
	},
	methods: {
		// sliderMove() {
		// },
		// slideChangeTransitionStart() {
		// }
	},
}
